import { typography } from '@dixa/lib-shared-tokens';
export const tickProps = {
    fontFamily: typography.family.default,
    fontSize: typography.size['200'],
    fill: typography.color['tertiary'],
};
export const tickCount = 5;
export const visualizationIcons = {
    bar: 'chart-bar',
    line: 'activity',
};
